<template>
  <div>
    <el-table
      :empty-text="$t('CMSProduct.noOrigins')"
      :data="origins"
      stripe
      :cell-style="{padding:'2px'}"
      style="width: 100%">
      <el-table-column
       prop="country.name"
       :label="$t('CMSProduct.country')">
      </el-table-column>
      <el-table-column
      prop="region.name"
      :label="$t('CMSProduct.region')">
      </el-table-column>
      <el-table-column
      prop="city.name"
      :label="$t('CMSProduct.city')">
      </el-table-column>
      <el-table-column align="right">
        <template slot="header" slot-scope="scope">
           <el-button size="small" @click="openOriginDialog" :disabled="origins.length>=max">{{  $t('CMSProduct.addOrigin') }} <i class="el-icon-circle-plus-outline"></i></el-button>
         </template>
        <template slot-scope="scope" >
          <el-button size="mini" circle type="danger" @click="removeOrigin(scope.$index)"><i class="mdi mdi-delete fs-15"></i></el-button>
        </template>
      </el-table-column>
    </el-table>
    <OriginDialog :visible="originDialogVisible" @add="v=> $emit('add',v)" @close="closeOriginDialog"></OriginDialog>
  </div>
</template>
<script>

import OriginDialog from './origin-dialog'

export default {
  name: 'Origins-table',
	props: {
		origins : {type : Array},
    max : {type : Number, default : Infinity},
	},
  data() {
    return {
      originDialogVisible : false,
    };
  },
  components: {
    OriginDialog
  },
	methods: {
    openOriginDialog(){
      this.originDialogVisible=true;
    },
    closeOriginDialog(){
      this.originDialogVisible=false;
    },
    removeOrigin(index){
      this.$emit("remove", index);
    }
	},
	computed: {

	}
}
</script>
<style>
</style>
